/**
 * @desc 更新合同
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(pano: string, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/updateContact/${pano}`, {
      method: "POST",

      ...options,
    }),
  );
}
